import { Button, FormControl, Grid, SvgIcon, TextField } from '@mui/material';
import CountZonesTable from './CountZonesTable';
import { CountZonesResponse } from '../../../app/services/api/generated';
import LoadingWheel from '../../../components/ui/LoadingWheel';
import { PlusCircle } from '../../../assets';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { UserContext } from '../../../components/shared/useUser';

const MainBox = (props: { zones: CountZonesResponse[], storeID: string, loadData: () => void, isLoading: boolean }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);
  const hasRightToEdit: boolean = hasPermissionTo(['StockLocationWrite']) || hasPermissionTo(['StockCountAdmin']);
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Grid container
      sx={{ pt: '8px' }}>
      <Grid item
        xs={8}
        sx={{ pb: '8px' }}>
        <FormControl>
          <TextField
            label={t('search') + ':'}
            size='small'
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </FormControl>
      </Grid>
      <Grid item
        xs={4}
        sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          size='lg'
          sx={{ ml: 4 }}
          onClick={() => navigate('/create-edit-count-zone')}
          startIcon={<SvgIcon><PlusCircle /></SvgIcon>}
          disabled={!hasRightToEdit}
        >
          {t('createNew')}
        </Button>
      </Grid>
      <Grid item
        xs={12}>
        <CountZonesTable
          list={props.zones}
          storeID={props.storeID}
          loadData={props.loadData}
          searchTerm={searchTerm}
          isLoading={props.isLoading} />
      </Grid>
    </Grid>
  );
};

const CountZonesBox = (props: { zones: CountZonesResponse[], loadData: () => void, storeID: string, isLoading: boolean }) => {
  return props.isLoading ? (
    <LoadingWheel />
  ) : (
    <MainBox zones={props.zones}
      storeID={props.storeID}
      loadData={props.loadData}
      isLoading={props.isLoading} />
  );
};

export default CountZonesBox;
